export default {
  install(app) {
    const context = require.context("./", false, /\.js$/);
    context.keys().forEach((fileName) => {
      if (fileName === "./index.js") return; // 忽略自己
      const directive = context(fileName).default;
      const name = fileName.replace(/\.\/(.*)\.js$/, "$1");
      app.directive(name, directive);
    });
  },
};
